import {useFormik} from 'formik'
import React, {useCallback, useState} from 'react'
import {Modal} from 'react-bootstrap'
import Container from 'react-bootstrap/Container'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import {TIMEZONES} from '../../../../../../_gori/constants'
import useCancelToken from '../../../../../../_gori/hooks/UseCancelToken'
import {Button, SelectFormik, ValidationErrorModal} from '../../../../../../_gori/partials/widgets'
import {useAuth} from '../../../../auth'
import UserService from '../../../../users/core/_requests'
import SettingsService from '../../../core/_requests'

type Props = {
  show: boolean
  handleClose: () => void
}

const TimeZoneModal: React.FC<Props> = ({show, handleClose}) => {
  const intl = useIntl()
  const {currentUser, setCurrentUser} = useAuth()
  const {newCancelToken} = useCancelToken()
  const [validationErrors, setValidationErrors] = useState<any>()

  const formik = useFormik({
    initialValues: {
      timezone: currentUser?.user_profiles?.general?.timezone?.value,
    },
    enableReinitialize: true,
    onSubmit: async (values, {setSubmitting}) => {
      setSubmitting(true)

      try {
        const config = {cancelToken: newCancelToken()}
        const payload = {
          ids: [currentUser?.id],
          timezone: values.timezone,
        }
        await SettingsService.updateGeneral(payload, config)
        setCurrentUser(await UserService.getUser(config))
        toast.success(intl.formatMessage({id: 'UPDATED_SUCCESSFULLY'}))
      } catch (error: any) {
        setValidationErrors(error?.response)
      } finally {
        setSubmitting(false)
      }
    },
  })

  const handleCloseModal = useCallback(() => {
    if (formik.isSubmitting) {
      return
    }
    handleClose()
    formik.resetForm()
  }, [formik, handleClose])

  return (
    <>
      {validationErrors && (
        <ValidationErrorModal
          handleClose={() => {
            setValidationErrors(undefined)
          }}
          response={validationErrors}
        />
      )}

      <Modal
        id='gori_modal_change_timezone'
        tabIndex={-1}
        aria-hidden='true'
        centered
        dialogClassName='modal-size-md h-auto'
        contentClassName='modal-padding'
        show={show}
        backdrop='static'
        onHide={handleCloseModal}
      >
        <Modal.Header closeButton>
          <Modal.Title bsPrefix={'fw-bolder fs-1'}>
            {intl.formatMessage({id: 'TIME_ZONE'})}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='vh-75 overflow-auto'>
          <Container>
            <div className='col-12'>
              <p className='form-label text-gray-600'>
                {intl.formatMessage({id: 'TIME_ZONE_TEXT'})}
              </p>
            </div>
            <div>
              <SelectFormik
                emptyDefault={false}
                options={TIMEZONES}
                name='timezone'
                formik={formik}
                placeholder={intl.formatMessage({id: 'PLEASE_CHOOSE'})}
                disabled={formik.isSubmitting}
                styleInput={{backgroundColor: '#fff !important', height: '42px'}}
              />
            </div>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex justify-content-end'>
            <Button
              className='btn btn-advanced-secondary me-2'
              label={intl.formatMessage({id: 'CANCEL'})}
              loadingText={intl.formatMessage({id: 'CANCEL'})}
              event={handleCloseModal}
              disabled={formik.isSubmitting}
            />
            <Button
              className='btn btn-advanced-primary'
              label={intl.formatMessage({id: 'SAVE'})}
              loadingText={intl.formatMessage({id: 'SAVE'})}
              disabled={formik.isSubmitting}
              event={formik.submitForm}
              loading={formik.isSubmitting}
            />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export {TimeZoneModal}
